import { render, staticRenderFns } from "./CrmBuilderMain.vue?vue&type=template&id=90000814&scoped=true&lang=true&"
import script from "./CrmBuilderMain.vue?vue&type=script&lang=js&"
export * from "./CrmBuilderMain.vue?vue&type=script&lang=js&"
import style0 from "./CrmBuilderMain.vue?vue&type=style&index=0&id=90000814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90000814",
  null
  
)

export default component.exports